import "jQuery";

'use strict';

(function($) {
    $(document).on('change', '.custom-file-field-wrapper :file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });
    $(document).ready( function() {
        $('.custom-file-field-wrapper :file').on('fileselect', function(event, numFiles, label) {
            let $wrap = $(this).closest('.custom-file-field-wrapper');
            let $file_info = $('.file-info', $wrap);
            if($file_info.length <= 0) {
                $file_info = $('<div class="file-info"></div>').appendTo($wrap);
            }
            if(numFiles > 0) {
                $file_info.text(label);;
            } else {
                $file_info.text('');
            }
        });
    });
})( jQuery );